module.exports = __webpack_public_path__ + "assets/icons/ic_supervisor_account-8111.svg";